import { render, staticRenderFns } from "./labelList.vue?vue&type=template&id=38b39d16&scoped=true"
import script from "./labelList.vue?vue&type=script&lang=js"
export * from "./labelList.vue?vue&type=script&lang=js"
import style0 from "./labelList.vue?vue&type=style&index=0&id=38b39d16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b39d16",
  null
  
)

export default component.exports